import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import * as Chartist from 'chartist';
import { Observable } from 'rxjs/Observable';

declare var $:any;

@Component({
    selector: 'dashboard-cmp',
    moduleId: module.id,
    templateUrl: 'dashboard.component.html'
})

export class DashboardComponent implements OnInit{

    image_folders : AngularFireList<any>;
    folder: AngularFireList<any>;
    items: Observable<any[]>;
    img : Observable<any[]>;
    images = [];
    
    today =((new Date().toString()).split(' ').slice(0, 4).join(' ')) +" 00:00:00 GMT+0200 (SAST)";

    store ="Boardroom";
    //pictures
    pictures= [];
     pictureLength;
    sendLength = 0;
    notSendLength = 0;

    errorCounter = 0;

    //filter
    uniqueDates;
    uniqueStores;


    //loader 
     picturesLoader =true;
     imageLoader =true;


    constructor(public db : AngularFireDatabase){
        console.log(new Date().toString() );
        this.image_folders = db.list('pictures');

        this.items = this.image_folders.snapshotChanges();
        this.items.subscribe(pictures =>{
            this.pictures = [];
            var dates =[];
            var stores = []
            this.pictureLength = pictures.length;
          //  console.log(pictures.length);
    
            for(var i=0; i < pictures.length ; i ++){
                //console.log(pictures[i])
                 const   pic = pictures[i].payload.val();
                // console.log(pic);
                var dateString= new Date(pic.createdAt).toString();
                console.log(dateString);
                dateString = dateString.split(' ').slice(0, 4).join(' ')
                // console.log(dateString);
                this.pictures.push({
                    key : pictures[i].key,
                    createdAt: pic.createdAt,
                    file: pic.file,
                    mailed: pic.mailed ,
                    url:  pic.url,
                    store: pic.storeName,
                    date: dateString +" 00:00:00 GMT+0200 (SAST)"
                })
                dates.push( dateString +" 00:00:00 GMT+0200 (SAST)");
                stores.push (pic.storeName);
                
               
                this.picturesLoader =false;
            }
            this.uniqueDates = this.unique(dates);
            this.uniqueStores = this.unique(stores);
            this.uniqueDates.reverse();
            this.uniqueStores.reverse();
         //   console.log(this.pictures);
            this.count();
            this.pictures.reverse();
            });
            /**folders.forEach(folder=>{
                console.log(folder);
                console.log(folder.key);
                console.log(folder.val());
                this.folders.push({
                    name: folder.key
                })
                console.log(this.folders);*/
          
        }
        /***/
   
    
    ngOnInit(){
    }

    onInput(ev, value){
        console.log(this.today);
    }
    onChange(ev, value){
        console.log(this.today);
    }
    unique(array) {
        var arr = [];
        for(var i = 0; i < array.length; i++) {
            if(arr.indexOf(array[i]) == -1) {
                arr.push(array[i]);
            }
        }
        return arr; 
    }

    remove(key){
        console.log(key+" removed");
       this.image_folders.remove(key);
        
    }
    count(){
        this.sendLength = 0;
        this.notSendLength = 0;
        var countp = 0;
        var countn = 0;
        this.pictures.forEach(picture =>{
                if(picture.mailed){
                   countp ++;    
                }
                else if(!picture.mailed){
                    countn ++;    
                }

        })
        this.sendLength = countp;
        this.notSendLength = countn;
      //  console.log(this.sendLength);
     //   console.log(this.notSendLength);
    }
    /** 
    errorCount(event, key){
        console.log(event);
        this.errorCounter ++;
        console.log(this.errorCounter);
        this.delete(key);
    }

    delete(key){
        this.folder.remove(key);
    }

    viewImagesInFolder(folderName){
        this.imageLoader =true;
        console.log(folderName);
       
        this.folder = this.db.list('pictures/'+folderName);
        this.img = this.folder.snapshotChanges();
        this.img.subscribe(images =>{
            this.images =[];
            console.log(images);
            for(var i=0; i <images.length ; i++){
                var imageVal = images[i].payload.val();
                this.images.push({
                    key : images[i].key,
                    image : imageVal.downloadURL,
                    name : imageVal.fileName
                })
                this.imageLoader= false;

            }
            console.log(this.images)
        })
    }*/
}



// WEBPACK FOOTER //
// /Users/makebetter/Documents/sportsceneDash/src/app/dashboard/dashboard.component.ts